import { ERROR_MESSAGE_KEYS, UNKNOWN_ERROR_KEY } from "./errorKeys";

/**
 * Helper function to extract error message from API response.
 * Handles the JSend response format used by the account API.
 * It now accepts the i18next `t` function to translate error codes.
 *
 * @param {Error} error The error object, likely from axios.
 * @param {Function} t The i18next translation function.
 * @returns {string} A user-friendly, translated error message.
 */
export const extractErrorMessage = (error, t) => {
  if (error.response && error.response.data) {
    const { data } = error.response;
    const errorCode = data.code;

    // Translate the error code via the static key map (no dynamic key). A code
    // we don't map for falls through to the message extraction below.
    if (t && errorCode) {
      const translationKey = ERROR_MESSAGE_KEYS[errorCode];
      if (translationKey) {
        return t(translationKey);
      }
    }
  }

  // Any unmapped error falls through to the generic message — raw backend
  // strings / codes / axios "status code NNN" text must never reach the UI.
  return t ? t(UNKNOWN_ERROR_KEY) : "An unexpected error occurred.";
}; 